import React, {useState, useEffect, useContext} from 'react'
import UserContext from '../../context/context'
import styled from 'styled-components';
// import { Link } from 'react-router-dom';
import { history } from '../../_helpers';

import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
// convertToRaw로 변환시켜준 원시 JS 구조를 HTML로 변환.
import draftToHtml from 'draftjs-to-html';

function CompanyInfoView(){
  const [state, actions] = useContext(UserContext);
  const [companyInfo, setCompanyInfo] = useState(null)
  const [companyRa, setCompanyRa] = useState()

  const [hhinfo, setHhinfo] = useState()
  

  const [editorToHtml, setEditorToHtml] = useState(EditorState.createEmpty())

  let user = JSON.parse(String(localStorage.getItem('user')))
  
  let header = {}

  if(user){
    header = {Authorization: `JWT ${user.token}`}
  } else{
    header = {}
  }

  const comId = history.location.pathname.split('/')[2]

  
  useEffect(()=>{
    async function fetchCompany(){
      fetch(state.awslink + "/user/company/?id=" + comId, {
        method: 'GET',
        // headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        if(json.intro){
          let parsed = EditorState.createWithContent(convertFromRaw(JSON.parse(json.intro))) 
          setEditorToHtml(draftToHtml(convertToRaw(parsed.getCurrentContent())))
        }
        setCompanyInfo(json)

        fetch(state.awslink + "/api/generalra/?comId=" + comId, {
          method: 'GET',
          // headers: header,
        })
        .then(response => response.json())
        .then(json=>{
          console.log(json)
          setCompanyRa(json)
        })
      })
      .catch(error=>{
        console.log(error)
        fetch(state.awslink + "/user/hhinfo/?id=" + comId,{
          method: 'GET',
        })
        .then(res => res.json())
        .then(json=>{
          setHhinfo(json)
          fetch(state.awslink + "/api/generalra/?hhId=" + comId, {
            method: 'GET',
            // headers: header,
          })
          .then(response => response.json())
          .then(json=>{
            console.log(json)
            setCompanyRa(json)
          })
        })
      })
    }

    async function fetchCompanyRa(){
      fetch(state.awslink + "/api/generalra/?comId=" + comId, {
        method: 'GET',
        // headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        setCompanyRa(json)
      })
    }


    fetchCompany();
    // fetchCompanyRa();
  },[])

  
  return(
    <>
      <Wrapper>
        <CompanyWrapper>
          {companyInfo?
          <div >
            <div >
              <img
                src={companyInfo.user.logolink ? companyInfo.user.logolink : "dummy"}
                onError={(e)=>{
                  e.target.src = state.noimage
                }}
              />
            </div>
            <div>
              {companyInfo.title}
            </div>
            
            <div>
              {companyInfo.tag.map((item, index)=>{
                return(
                  <div>
                    # {item}
                  </div>
                )
              })}
              
            </div>
          </div>
          : 
          hhinfo && 
            <div >
              <div >
                <img
                  src={hhinfo.profilelink ? hhinfo.profilelink : "dummy"}
                  onError={(e)=>{
                    e.target.src = state.noimage
                  }}
                />
              </div>
              <div>
                {hhinfo.realname}
              </div>
              
              <div>
                {hhinfo.tag.map((item, index)=>{
                  return(
                    <div>
                      # {item}
                    </div>
                  )
                })}
              </div>
            </div>
          }
          
        </CompanyWrapper>
        
        <RaWrapper>
          {companyRa ?
          <>
          <InfoForm>
            <div>
              {/* <header style={{backgroundImage: `url("https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/noimage.png")`}}></header> */}
              {/* <div className={"com-header"}>
                <h1>{ra.title}</h1>
                <h4>{companyInfo.title}</h4>
                <p>{ra.created.split('T')[0]}</p>
                <div>
                  <div>{ra.field}</div>
                  {ra.job.map((item, index)=>{
                    return(
                      <div>{item}</div>
                    )
                  })}
                </div>
              </div> */}
              {/* {companyRa.map((item, index)=>{
                  return(
                  <div>{item.title}</div>
                  )
                })} */}
              <div className={"com-card"}>
                <h4>진행중인 채용포지션</h4>
                {companyRa.map((item, index)=>{
                  return(
                  <div className={"com-card-ra"}>
                    <div>
                      <div className={"qu-title"}>{item.title}</div>
                      <div className={"qu-add"}>채용보상금 1,000,000원</div>
                      <div className={"qu-add"}>{item.enddate}</div>
                    </div>
                  </div>
                  )
                })}
              </div>

              {companyInfo ? 
              <>
              <div className={"com-card"}>
                <h4>회사 개요</h4>
                <div className={"com-card-info"}>
                  <div>홈페이지</div>
                  <div>{companyInfo.homepage}</div>
                </div>
                <div className={"com-card-info"}>
                  <div>직원수</div>
                  <div>{companyInfo.people}</div>
                </div>
                <div className={"com-card-info"}>
                  <div>주소</div>
                  <div>{companyInfo.address} {companyInfo.addressDetail}</div>
                </div>
                <div className={"com-card-info"}>
                  <div>설립년도</div>
                  <div>{companyInfo.year}</div>
                </div>
                <div className={"com-card-info"}>
                  <div>투자유치</div>
                  <div>{companyInfo.investment}</div>
                </div>
                <div className={"com-card-info"}>
                  <div>매출</div>
                  <div>{companyInfo.revenue}</div>
                </div>
              </div>
              
              <div className={"com-card"}>
                <h4>회사 소개</h4>
                {/* <div>{ra.description}</div> */}
                {companyInfo.intro && <div dangerouslySetInnerHTML={{__html: editorToHtml}}/>}
              </div>
              </>
              :
              null
              }


              <div className={"com-field"}>
                {/* <div>
                  <span>근무지</span>
                  <span>{ra.workadd}</span>
                </div>
                <div>
                  <span>마감일</span>
                  <span>{ra.enddate}</span>
                </div>
                <div>
                  <span>예상연봉</span>
                  <span>{ra.salary}</span>
                </div>
                <div>
                  <span>선호경력</span>
                  <span>{ra.workyears}</span>
                </div> */}
              </div>

            </div>
          </InfoForm>

          <RightForm>
            <BeforeRight>
              {/* <div>
                <h3>채용보상금</h3>
                <ul>
                  <li>
                    <div>
                      추천인
                    </div>
                    <div>
                      500,000 원
                    </div>
                  </li>
                  <li>
                    <div>
                      지원자
                    </div>
                    <div>
                      500,000 원
                    </div>
                  </li>
                </ul>
              </div> */}

              {/* <ButtonForm>
                <button onClick={()=>actions.setIsShowing(!state.isShowing)}>
                  로그인
                </button>
              </ButtonForm> */}
            </BeforeRight>
          </RightForm>
          </>
          :null}
        </RaWrapper>
      </Wrapper>   
      {/* } */}
    </>
  )
}
const Wrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 50px);
  margin-top: 45px;
  display: block;
  position: relative;
`

const RaWrapper = styled.div`
  max-width: 1060px;
  width: 90%;
  display: block;
  margin: 0 auto;
  background-color: whitesmoke;
  
`

const CompanyWrapper = styled.div`
  /* max-width: 1060px; */
  width: 100%;
  display: flex;
  margin: 0 auto;
  background-color: rgba(255, 255, 255, .8);
  height: 300px;

  border-bottom: 1px solid rgba(0,0,0,0.2);
  margin-bottom: 10px;

  justify-content: center;
  align-items: center;

  >div{
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    >div{
      :first-child{
        width: 100px;
        height: 100px;
        margin-bottom: 5px;
        position: relative;

        display: flex;
        justify-content: center;
        align-items: center;

        overflow: hidden;

        img{
          width: 100%;
          background-position-x:50%;
          background-position-y:50%;
          background-size: cover;
        }
        
      }
      :nth-child(2){
        width: 100%;
        height: 20px;
        margin-bottom: 5px;
      }
      :last-child{
        display: block;
        >div{
          display: inline-block;
          font-size: 0.8rem;
          border: .5px solid rgba(0,0,0,0.2);
          border-radius: 12px;
          padding: 7px;
          padding-left: 10px;
          padding-right: 10px;
          margin: 5px;
        }
      }
    }

  }
`

const InfoForm = styled.div`
  width: 65%;
  box-sizing: border-box;
  padding: 5px;
  padding-left: 0px;
  display: inline-block;
  margin: 0;
  
  text-align: left;
  vertical-align: top;

  >div{
    width: 100%;
    /* background-color: rgba(255, 255, 255, 0.8); */
    /* background-color: rgba(255, 255, 255, 0.8); */
    /* border-radius: 5px;
    border: .5px solid rgba(0,0,0,0.2); */
    /* box-sizing: border-box;
    padding: 10px; */

    >header{
      height: 400px;
      background-position-x:50%;
      background-position-y:50%;
      background-size: cover;
    }

    .com-card{
      background-color: rgba(255, 255, 255, 0.8);
      box-sizing: border-box;
      padding: 20px;
      border-radius: 5px;
      border: .5px solid rgba(0,0,0,0.2);
      /* margin-top: 10px; */
      margin-bottom: 10px;
      h4{
        margin: 0;
        margin-bottom: 10px;
      }
      .com-card-ra{
        display: inline-block;
        width: 50%;
        box-sizing: border-box;
        padding: 5px;
        vertical-align: top;
        >div{
          background-color: rgba(255, 255, 255, 0.8);
          border-radius: 5px;
          border: 2px solid rgba(0,0,0,0.1);
          /* height: 100px; */
          box-sizing: border-box;
          padding: 10px;
          min-height: 95px;
          
        }
      }
      .com-card-info{
        width: 100%;
        display: block;
        >div{
          display: inline-block;
          margin-bottom: 10px;
          :first-child{
            width: 25%;
            vertical-align: top;
            color: rgba(0,0,0,0.6);
          }
          :last-child{
            width: 75%;
            vertical-align: top;
          }
        }
      }
    }
  }
`


const RightForm = styled.div`
  width: 35%;
  box-sizing: border-box;
  padding: 5px;
  padding-right: 0px;
  display: inline-block;
  margin: 0;
  
  text-align: left;
  vertical-align: top;
  
`

const BeforeRight = styled.div`
  height: 300px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 5px;
  border: .5px solid rgba(0,0,0,0.2);
  position: relative;
  box-sizing: border-box;
  padding: 20px;

  >div{
    >h3{
      margin-top: 0;
    }
    >ul{
      list-style: none;
      display: block;
      margin: 0;
      padding: 0;
      padding-top: 20px;
      >li{
        display: inline-block;
        width: 50%;
        >div{
          margin-bottom: 10px;
          :first-child{
            font-size: 0.9rem;
            color: rgba(0,0,0,0.7);
          }
          :last-child{
            font-weight: bold;
          }
        }
      }
    }
  }
`


const ButtonForm = styled.div`
  width: calc(100% - 40px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 20px;
  >button{
    
    :first-child{
      cursor: pointer;
      margin: 0;
      margin-bottom: 10px;
      width: 100%;
      height: 45px;
      border-radius: 10px;
      background-color: white;
      border: .5px solid rgba(253,134,18, 0.6);
      color: rgba(253,134,18, 0.8);
      font-weight: bold;
      font-size: 1.1rem;
    }
    :last-child{
      cursor: pointer;
      margin: 0;
      margin-bottom: 10px;
      width: 100%;
      height: 45px;
      border-radius: 10px;
      background-color: rgba(253,134,18, 0.6);
      border: none;
      color: white;
      font-weight: bold;
      font-size: 1.1rem;
    }

    :disabled{
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`
export default CompanyInfoView